import * as React from "react";
const SvgFiBrandsTwitch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M6 0 1.714 4.286v15.429h5.143V24l4.286-4.286h3.43L22.285 12V0zm14.571 11.143-3.429 3.429h-3.429l-3 3v-3H6.857V1.714h13.714z"
    />
    <path
      fill="#151A2D"
      d="M18 4.714h-1.714v5.143H18zM13.285 4.714h-1.714v5.143h1.714z"
    />
  </svg>
);
export default SvgFiBrandsTwitch;
